import type { PackagingType } from '@models/packaging'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import packagingApi from './actions'
import { packagingKeys } from './constants'

export interface UsePackagingData {
  packagingTypes: PackagingType[]
  packagingTypesMap: Map<number, PackagingType>
}

const selectData = (data: PackagingType[]): UsePackagingData => {
  return {
    packagingTypes: data,
    packagingTypesMap: new Map(
      data.map(packagingType => [packagingType.id, packagingType]),
    ),
  }
}

const usePackagingTypes = (companyId: number) => {
  const query = useQuery<PackagingType[], AxiosError, UsePackagingData>(
    packagingKeys.root(companyId),
    () => packagingApi.getPackagingTypes(companyId),
    { select: selectData, enabled: !!companyId },
  )

  return query
}

export default usePackagingTypes
